var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "owa-modal-frame",
    {
      attrs: {
        title: "Cancel Subscription?",
        "has-actions": "",
        "is-showing": _vm.isShowing,
      },
      on: {
        "close-modal": function ($event) {
          return _vm.$emit("close-modal")
        },
      },
    },
    [
      _c("p", [
        _vm._v(
          "\n    You can continue to use all of the icons, features, and services your subscription provides up until your subscription ends on\n    "
        ),
        _c("strong", [
          _c("time", { attrs: { datetime: _vm.subscription.periodEndAt } }, [
            _vm._v(_vm._s(_vm.periodEndAtDate)),
          ]),
        ]),
        _vm._v(". But you'll lose access to…\n  "),
      ]),
      _vm._v(" "),
      _c("owa-subscription-features", {
        attrs: { "is-showing-backer-perks": _vm.hasBackerSubscription },
      }),
      _vm._v(" "),
      _c(
        "template",
        { slot: "actions" },
        [
          _c("owa-action-button", {
            attrs: {
              "is-processing": _vm.isProcessing,
              "icon-name": "faBan",
              "is-processing-label": "Cancelling Subscription...",
              label: "Cancel Subscription",
              theme: "danger",
            },
            on: { click: _vm.cancelSubscription },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }